import React from 'react';
import { Link } from 'react-router-dom';

const LandingPage = () => {
  return (
    <div className="landing-container">
      <section className="hero-section">
        <h1>MemoryMind AI</h1>
        <p className="hero-subtitle">Digital Memory Support for Alzheimer's Patients</p>
        <p className="hero-text">
          A compassionate AI-powered memory companion designed specifically for individuals 
          living with Alzheimer's disease. Preserve your precious memories and strengthen 
          cognitive connections through innovative memory palace techniques.
        </p>
        <Link to="/new-memory" className="cta-button">Begin Your Memory Journey</Link>
      </section>

      <section className="for-patients-section">
        <h2>Specialized for Alzheimer's Care</h2>
        <div className="patient-benefits-grid">
          <div className="benefit-card">
            <h3>Early Stage Support</h3>
            <p>
              Ideal for early-stage Alzheimer's patients to preserve current memories 
              and maintain cognitive function through regular memory exercises.
            </p>
          </div>
          <div className="benefit-card">
            <h3>Gentle Assistance</h3>
            <p>
              User-friendly interface with clear instructions and patient-focused design 
              to reduce anxiety and frustration during memory recording.
            </p>
          </div>
          <div className="benefit-card">
            <h3>Family Connection</h3>
            <p>
              Share your memory palace journeys with family members to strengthen bonds 
              and maintain meaningful connections through shared memories.
            </p>
          </div>
        </div>
      </section>

      <section className="features-section">
        <h2>Memory Support Features</h2>
        <div className="features-grid">
          <div className="feature-card">
            <h3>Voice Memory Recording</h3>
            <p>
              Simply speak your memories naturally - our AI assistant will transcribe 
              and organize them into vivid memory palaces for easier recall.
            </p>
          </div>
          <div className="feature-card">
            <h3>Guided Memory Prompts</h3>
            <p>
              Gentle prompts help you recall important details and create fuller, 
              richer memory records for future reference.
            </p>
          </div>
          <div className="feature-card">
            <h3>Memory Training Exercises</h3>
            <p>
              Regular cognitive exercises designed specifically for Alzheimer's patients 
              to strengthen memory recall and maintain mental acuity.
            </p>
          </div>
          <div className="feature-card">
            <h3>Visual Memory Palaces</h3>
            <p>
              Transform memories into visual journeys through familiar spaces, making 
              them easier to revisit and remember.
            </p>
          </div>
        </div>
      </section>

      <section className="research-section">
        <h2>Based on Memory Research</h2>
        <div className="research-content">
          <p className="research-text">
            Our approach combines proven memory palace techniques with modern AI technology, 
            designed in consultation with Alzheimer's specialists. Memory palaces have been 
            shown to be particularly effective for individuals with early-stage Alzheimer's, 
            helping maintain cognitive function and preserve precious memories.
          </p>
          <div className="research-stats">
            <div className="stat-card">
              <h4>Memory Retention</h4>
              <p>Memory palace techniques can improve recall by up to 50% for early-stage patients</p>
            </div>
            <div className="stat-card">
              <h4>Cognitive Exercise</h4>
              <p>Regular memory training may help slow cognitive decline</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <h2>Start Preserving Your Memories Today</h2>
        <p>
          Take the first step in your memory preservation journey. Our gentle, 
          patient-focused approach makes it easy to begin.
        </p>
        <div className="cta-buttons">
          <Link to="/new-memory" className="primary-cta">Create Your First Memory</Link>
          <Link to="/enhanced-journaling" className="secondary-cta">Try Voice Recording</Link>
        </div>
      </section>
    </div>
  );
};

export default LandingPage; 